import React from 'react';
import {connect} from 'react-redux';
import ListOfCollaboratorsDetails from './components/list-of-collaborators-details/index';
import Loader from "../../../../../../../../components/sprite/components/loader/index";
import './index.css';

class ListOfCollaborators extends React.Component {
    render (){
        return (
            <div className={`list-of-collaborators${this.props.disabled ? ' disabled' : ''}`}>
                <ListOfCollaboratorsDetails/>
                {
                    this.props.isNewAddedCollaboratorsLoading
                        ?
                        <div className="collaborators-loading d-flex align-items-center">
                            <Loader/>
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
	return {
        isNewAddedCollaboratorsLoading: state.sharingDetailsReducer.isNewAddedCollaboratorsLoading,
	};
};

export default connect(mapStateToProps)(ListOfCollaborators);
